// App-wide company client state: feature flags, branding logo, and the active
// sport's terminology lookup. See CLAUDE.md "Client state lives in a per-context store".
import { createStore } from './create-store';
import logo from '../../assets/logo.png';
import { Sport, SportTermLookup } from '../types';
import { SPORT_TERMINOLOGY } from '../constants';

const [useCompanyHasAutomation, , setCompanyHasAutomation] = createStore<boolean>(false);
export { useCompanyHasAutomation, setCompanyHasAutomation };

// Null until the active association loads, so a surface can wait instead of acting on a guess.
const [useCompanyReportCardsSetting, , setCompanyHasReportCards] = createStore<boolean | null>(null);
export const useCompanyHasReportCards = (): boolean => useCompanyReportCardsSetting() === true;
export { useCompanyReportCardsSetting, setCompanyHasReportCards };

const [useCompanyHasCalibrationVideos, , setCompanyHasCalibrationVideos] = createStore<boolean>(false);
export { useCompanyHasCalibrationVideos, setCompanyHasCalibrationVideos };

const [useCompanyLogo, , setCompanyLogoValue] = createStore(logo);
export { useCompanyLogo };
// Custom logos aren't persisted yet — the setter always resolves to the bundled asset.
export const setCompanyLogo = (_logo: string) => setCompanyLogoValue(logo);

const [useCompanySportTerminology, , setCompanySportTerminology] =
  createStore<SportTermLookup>(SPORT_TERMINOLOGY[Sport.default]);
export { useCompanySportTerminology };

const [useCompanySport, , setCompanySportValue] = createStore<Sport>(Sport.default);
export { useCompanySport };
export const setCompanySport = (sport: Sport) => {
  setCompanySportValue(sport);
  setCompanySportTerminology(SPORT_TERMINOLOGY[sport]);
};
